import axios from 'axios'
import router from '@/router'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:5214/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 从localStorage获取token
    const token = localStorage.getItem('accessToken')
    if (token && token !== 'null' && token !== 'undefined') {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // FormData 请求时删除默认的 Content-Type，让浏览器自动设置（含 boundary）
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    console.log('请求拦截器 - Token:', token ? `Bearer ${token.substring(0, 20)}...` : 'null')
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    
    // 如果返回的状态码为200，说明接口请求成功
    if (res.success === true || response.status === 200) {
      return res
    } else {
      // 业务错误 - 创建一个包含响应数据的错误对象
      console.error('业务错误:', res.message || '请求失败')
      const error = new Error(res.message || '请求失败')
      error.response = { data: res }
      error.code = res.code
      return Promise.reject(error)
    }
  },
  error => {
    console.error('响应错误:', error)
    
    if (error.response) {
      const { status, data } = error.response
      
      // 提取后端返回的错误信息
      const backendMessage = data?.message || data?.Message
      if (backendMessage) {
        // 将后端错误信息设置到 error.message 中
        error.message = backendMessage
      }
      
      switch (status) {
        case 401:
          // 未授权，清除token并跳转到登录页
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('userInfo')
          if (router.currentRoute.path !== '/login') {
            router.push('/login')
          }
          break
        case 403:
          console.error('没有权限访问')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器错误')
          break
        default:
          console.error(backendMessage || '请求失败')
      }
    } else if (error.request) {
      console.error('网络错误，请检查网络连接')
      error.message = '网络错误，请检查网络连接'
    }
    
    return Promise.reject(error)
  }
)

export default request
